import { render, staticRenderFns } from "./tenant-branding-info.vue?vue&type=template&id=4e2edbc5&"
import script from "./tenant-branding-info.vue?vue&type=script&lang=js&"
export * from "./tenant-branding-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports